import { render, staticRenderFns } from "./WechatMenu.vue?vue&type=template&id=81bdff88&scoped=true"
import script from "./WechatMenu.vue?vue&type=script&lang=js"
export * from "./WechatMenu.vue?vue&type=script&lang=js"
import style0 from "./WechatMenu.vue?vue&type=style&index=0&id=81bdff88&prod&lang=scss"
import style1 from "./WechatMenu.vue?vue&type=style&index=1&id=81bdff88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bdff88",
  null
  
)

export default component.exports